import { useState } from "react";
import useGlobalContext from "../../../hooks/useGlobalContext.js";
import { useActions, useStore } from "../../../store/index.js";
import { actions as OrderActions } from "../../../store/order/actions.js";
export const useTestConfirmation = () => {
    const store = useStore();
    const { isInternal } = useGlobalContext();
    const orderActions = useActions(OrderActions);
    const { order, addOnOrder } = store.order;
    if (!order) {
        throw new Error("Missing order data");
    }
    const queryParams = new URLSearchParams(location.search);
    if (!order.isTest && isInternal && Number(queryParams.get("test")) === 1) {
        console.warn("Overriding order");
        const confirmationType = queryParams.get("type");
        orderActions.fetchSuccess({
            ...order,
            isTest: true,
            ...(confirmationType && { orderStatus: confirmationType.toUpperCase() })
        });
        if (addOnOrder) {
            const addOnConfirmationType = queryParams.get("addOnType");
            orderActions.setAddOnOrder({
                ...addOnOrder,
                isTest: true,
                ...(addOnConfirmationType && { orderStatus: addOnConfirmationType.toUpperCase() })
            });
        }
    }
};
const useConfirmation = function () {
    useTestConfirmation();
    const [mpState, setMpState] = useState({ isLoading: false, multiProducts: [] });
    return { mpState, setMpState };
};
const ConfirmationController = (props) => {
    const confirmationData = useConfirmation();
    return props.children(confirmationData);
};
export default ConfirmationController;
